import script from "./CreateMeetingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateMeetingModal.vue?vue&type=script&setup=true&lang=js"

import "./CreateMeetingModal.vue?vue&type=style&index=0&id=2facfc9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2facfc9f"]])

export default __exports__